import React, { useState, useEffect } from "react";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import imageCompression from "browser-image-compression";
import Preloader from "../Preloader";
import { baseUrl } from "../Service/Register";
import { toast } from "react-toastify";

const ImageUpload = () => {
  const [btn, setBtn] = useState(false);
  const [allImage, setAllImage] = useState([]);
  const [rotationAngles, setRotationAngles] = useState([]);
  const [CImages, setCImages] = useState([]);
  const [imageNames, setImageNames] = useState([]);
  const [archieveImages, setArchieveImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const [orderNo, setOrderNo] = useState(localStorage.getItem("OrderNo") || "");

  useEffect(() => {
    if (orderNo) {
      getOrder();
    }
  }, [orderNo]);

  useEffect(() => {
    getOrder();
  }, []);

  const handleImage = async (event) => {
    const files = event.target.files;
    if (!files) return;

    const selected = Array.from(files);
    const previews = [];
    const compressedBase64Images = [];
    const names = [];
    const initialAngles = selected.map(() => 0);

    setRotationAngles((prevAngles) => [...prevAngles, ...initialAngles]);
    setLoading(true);

    for (const file of selected) {
      names.push(file.name);

      try {
        const options = {
          maxSizeMB: 0.3,
          maxWidthOrHeight: 500,
        };

        const compressedFile = await imageCompression(file, options);
        const base64String = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(compressedFile);
        });

        compressedBase64Images.push(base64String);
        previews.push(base64String);
      } catch (error) {
        console.error("Image compression failed:", error);
      }
    }

    //     setAllImage((prev) => [...prev, ...previews]);
    setCImages(compressedBase64Images);
    setImageNames(names);
    setLoading(false);

    const payload = [
      {
        formFile: compressedBase64Images.map((img) => ({
          base64: img.split(",")[1],
        })),
        OrderNo:
          localStorage.getItem("OrderNO") || localStorage.getItem("OrderNo"),
      },
    ];

    const formData = new FormData();
    formData.append("cell", JSON.stringify(payload));

    const endpoint = localStorage.getItem("token")
      ? "Order/EditCellImage"
      : "Order/SaveCellImage";

    try {
      const response = await fetch(`${baseUrl}${endpoint}`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const result = await response.json();
      toast.success(result.message);

      if (result.message) {
        setBtn(true);
      }

      getOrder();
    } catch (error) {
      console.error("Error saving/editing cell image:", error);
      toast.error("Failed to upload images");
    }
  };

  const deleteImage = async (indexToDelete) => {
    const orderNo =
      localStorage.getItem("OrderNO") || localStorage.getItem("OrderNo");
    const imageNameToDelete = allImage[indexToDelete].split("/").pop();
    try {
      const formData = new FormData();
      formData.append("OrderNo", orderNo);
      formData.append("ImageName", imageNameToDelete);

      const response = await fetch(`${baseUrl}Order/RemoveOrderImage`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to remove image from server");
      }
      getOrder();
      const result = await response.json();
      console.log("Image removed from server:", result);
      const updatedImages = allImage.filter(
        (_, index) => index !== indexToDelete
      );
      const updatedCImages = CImages.filter(
        (_, index) => index !== indexToDelete
      );
      const updatedNames = imageNames.filter(
        (_, index) => index !== indexToDelete
      );

      setAllImage(updatedImages);
      setCImages(updatedCImages);
      setImageNames(updatedNames);
      sessionStorage.setItem("CImages", JSON.stringify(updatedCImages));
      sessionStorage.setItem("ImageNames", JSON.stringify(updatedNames));
      setRotationAngles((prevAngles) =>
        prevAngles.filter((_, index) => index !== indexToDelete)
      );
    } catch (error) {
      console.error("Error deleting image:", error);
      alert("Failed to delete image. Please try again.");
    }
  };

  const rotateImage = (index) => {
    const newAngles = [...rotationAngles];
    newAngles[index] = (newAngles[index] + 90) % 360;
    setRotationAngles(newAngles);
  };

  const getOrder = async () => {
    const orderNo =
      localStorage.getItem("OrderNO") || localStorage.getItem("OrderNo");
    if (!orderNo) {
      console.error("OrderNo is missing in localStorage");
      return;
    }

    const formData2 = new FormData();
    formData2.append("orderNo", orderNo);

    try {
      const response = await fetch(`${baseUrl}Order/GetAllImagesOfOrder`, {
        method: "POST",
        body: formData2,
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch images. Please try again later.");
      }

      const data = await response.json();
      if (data && data.success === true) {
        const result = data.data;
        setBtn(true);
        const fullImageUrls = result.secondary.map(
          (imagePath) =>
            `https://api.mosaicphotos.com.au/${imagePath.replace(/\\/g, "/")}`
        );

        setAllImage(fullImageUrls);

        const fullImageArchieve = result?.archieve.map(
          (imagePath) =>
            `https://api.mosaicphotos.com.au/${imagePath.replace(/\\/g, "/")}`
        );

        console.log(fullImageUrls);
        setArchieveImages(fullImageArchieve);
      } else {
        console.error("No images found for this order");
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  // ----------MOVE IMAGES ARCHIEVE -----------
  const moveImageArchieve = async (index) => {
    const imageNameToMove = archieveImages[index].split("/").pop();
    try {
      const formData = new FormData();
      formData.append(
        "OrderNo",
        localStorage.getItem("OrderNO") || localStorage.getItem("OrderNo")
      );
      formData.append("ImageName", imageNameToMove);

      const response = await fetch(
        `${baseUrl}Order/MoveImageFromArchieveToCellsFolder`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to remove image from server");
      }

      const result = await response.json();
      toast.success(result.message);
      getOrder();
    } catch (error) {
      console.error("Error deleting image:", error);
      alert("Failed to delete image. Please try again.");
    }
  };

  if (loading === true) {
    return <Preloader />;
  }

  return (
    <>
      <Header />
      <center>
        <div className="main-container">
          <div className="upload-container">
            <h2>Upload Your "Cell Photos"</h2>
            <p style={{ color: "blue" }}>
              Press the add button below to select your Cell Photos and then
              press the Upload button at the bottom.
            </p>
            <p style={{ color: "red", marginTop: "-25px" }}>
              We recommend a minimum of 50 photos
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={40}
              height={40}
              fill="currentColor"
              className="bi bi-file-arrow-up"
              viewBox="0 0 16 16"
            >
              <path d="M8 11a.5.5 0 0 0 .5-.5V6.707l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 6.707V10.5a.5.5 0 0 0 .5.5" />
              <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1" />
            </svg>{" "}
            <br />
            <h2>Upload Image</h2>
            <input
              type="file"
              onChange={handleImage}
              multiple
              id="file-upload"
              accept="image/*"
            />
            <label htmlFor="file-upload">Add Photo</label>
          </div>
        </div>
        {btn ? (
          <a href="/frame">
            <button> Continue </button>
          </a>
        ) : (
          "Kindly hold off until all images have been uploaded."
        )}

        <br />

        {/* {allImage.length > 0 && (

          <div className="main-container">
            <div className="upload-container">
              <div className="grid-container1">
                {allImage &&
                  allImage.map((val, index) => (
                    <div key={index}>
                      <img
                        src={val}
                        style={{
                          transform: `rotate(${rotationAngles[index]}deg)`,
                        }}
                      />
                      <div className="rotate">
                        <RiDeleteBin6Line
                          onClick={() => deleteImage(index)}
                        />
                        <FaArrowRotateRight
                          onClick={() => rotateImage(index)}
                        />
                      </div>
                    </div>
                  ))}
              </div>
              <p style={{ marginTop: "20px", textAlign: "left" }}>
                Total Image: {allImage.length}
                {sessionStorage.setItem('Length', allImage.length)}
              </p>
            </div>
          </div>
        )} */}

        {allImage.length > 0 && (
          <div className="main-container">
            <div className="upload-container">
              <div className="grid-container1">
                {allImage &&
                  allImage.map((imageUrl, index) => (
                    <div key={index} className="image-container">
                      <img
                        src={imageUrl}
                        alt={`Uploaded Image ${index + 1}`}
                        style={{
                          borderRadius: "20px",
                          transform: `rotate(${rotationAngles[index]}deg)`,
                        }}
                      />
                      <div className="rotate">
                        <DeleteIcon onClick={() => deleteImage(index)} />
                        <RotateRightIcon onClick={() => rotateImage(index)} />
                      </div>
                    </div>
                  ))}
              </div>
              <p style={{ marginTop: "20px", textAlign: "left" }}>
                Total Images: {allImage.length}
                {sessionStorage.setItem("Length", allImage.length)}
              </p>
            </div>
          </div>
        )}

        {archieveImages.length > 0 && (
          <>
            <h5>Move To Cell</h5>
            <div className="main-container">
              <div className="upload-container">
                <div className="grid-container1">
                  {archieveImages &&
                    archieveImages.map((imageUrl, index) => (
                      <div key={index} className="image-container">
                        <img
                          src={imageUrl}
                          alt={`Move Image ${index + 1}`}
                          style={{
                            borderRadius: "20px",
                            transform: `rotate(${rotationAngles[index]}deg)`,
                          }}
                        />
                        <div className="rotate">
                          <DriveFileMoveIcon
                            titleAccess="Move To Cell"
                            onClick={() => moveImageArchieve(index)}
                          />
                        </div>
                      </div>
                    ))}
                </div>
                <p style={{ marginTop: "20px", textAlign: "left" }}>
                  Total Images: {archieveImages && archieveImages.length}
                  {sessionStorage.setItem("Length", allImage.length)}
                </p>
              </div>
            </div>
          </>
        )}

        <div className="spacer" />
        <div className="spacer" />
        <div className="info-text">
          “What photos pictures are best for creating a photo-mosaic.
          <a href="/faq">Read our tips</a>
        </div>
        <div className="overlay" id="overlay" />
        <div className="popup" id="popup">
          <h2>Image Library</h2>
          <p>Your uploaded images will appear here.</p>
          <button className="popup-close" id="popup-close">
            Close
          </button>
        </div>
      </center>
      <Footer />
    </>
  );
};

export default ImageUpload;
